<template>
  <v-form>
    <v-container fluid>
      <v-card elevation="12" class="pa-10">
        <v-row>
          <v-col>
            <h2>Classe ou Ativo Característico - GNEMA</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Sítio de Ação Primário</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-select
              :items="sitios"
              v-model="familia_quimica.id_sitio"
              item-text="sitio"
              item-value="id"
              label="Sítio Ativo"
              dense
              outlined
              no-data-text="Adicione um Sítio Ativo para selecionar"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Subgrupo</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-text-field
              v-model="familia_quimica.subgrupo"
              :rules="fieldRequired"
              label="Subgrupo"
              dense
              outlined
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-subheader>Classe</v-subheader>
          </v-col>
          <v-col class="d-flex" cols="3">
            <v-text-field
              v-model="familia_quimica.classe"
              :rules="fieldRequired"
              label="Classe"
              dense
              outlined
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn dark style="margin-left: 5px; margin-top: 2px" color="green" @click="salvar">
              Salvar
            </v-btn>
            <v-btn
              style="margin-left: 5px; margin-top: 2px"
              color="gray"
              to="/gnema/classe"
            >
              Cancelar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-snackbar
      v-model="snackbar"
      timeout="2000"
    >
      {{ aviso }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </v-form>
</template>

<script>
import { BASE_URL } from '../../util/constants';
export default {
  data: () => ({
    url: "https://apiadmin.allgeconsultoria.com/index.php/gnema/",
    overlay: false,
    snackbar: false,
    aviso: '',
    sitios: [],
    familia_quimica: {
      id: "",
      classe: '',
      subgrupo: '',
      id_sitio: '',
    },
    fieldRequired: [(v) => !!v || "Campo Obrigatorio"],
  }),
  created() {
    this.url = `${BASE_URL}gnema/`;
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.fetchSitios();
      if (this.$route.params.id !== "") {
        await this.fetchFamilia(this.$route.params.id);
      }
    },
    async fetchSitios() {
      try {
        let response = await fetch(`${this.url}sitio`);
        response = await response.json();
        this.sitios = response.map(item => ({id: item.id, sitio: item.sitio})).filter(familia => familia.sitio !== "").sort((a, b) => a.sitio > b.sitio ? 1 : -1);
      } catch (error) {
        this.sitios = [];
      }
    },
    async fetchFamilia(id) {
      if (id == undefined) return;
      try {
        let response = await fetch(`${this.url}classe/${id}`);
        response = await response.json();
        this.familia_quimica = response;
      } catch (error) {
        this.familia_quimica = {
          id: "",
          classe: '',
          subgrupo: '',
          id_sitio: '',
        };
      }
    },
    async salvar() {
      this.overlay = true;
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("classe", this.familia_quimica.classe);
      urlencoded.append("id_sitio", this.familia_quimica.id_sitio);
      urlencoded.append("subgrupo", this.familia_quimica.subgrupo);
      let method = (this.familia_quimica.id === '' ? 'POST' : 'PUT')
      
      let requestOptions = {
        method: method,
        headers: myHeaders,
        body: urlencoded,
      };

      fetch(`${this.url}classe/${this.familia_quimica.id}`, requestOptions)
        .then(response => response.json())
        .then(result => {
          console.log(result)
          this.overlay = false;
          this.aviso = 'Salvo com Sucesso';
          this.snackbar = true;
          setTimeout(() => this.$router.push(`/gnema/classe/`), 1000)
        })
        .catch(error => {
          console.log(error)
          this.overlay = false;
          this.aviso = 'Problema ao Salvar, entre em contato com o suporte';
          this.snackbar = true;
        });
    }
  },
};
</script>
